import React, { useEffect, useState } from "react";
import * as API from "./api.js";
import "./style.css";
import SearchHeader from "./ReusableComponents/SearchHeader/SearchHeader.js";
import TableView from "./ReusableComponents/TableView/TableView.js";
import { ActivityPopup } from "./ReusableComponents/ActivityPopup.js";
import ButtonWithIcon from "./ReusableComponents/ButtonWithIcon.js";
import downloadBurron from "./icons/DownloadVector.png"

const AdminDrones = (props) => {
  // const { user, type } = props.location.state
  const [drones, setDrones] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingCSV, setIsLoadingCSV] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [pagination, setPagination] = useState({
    pageNumber: 1,
    pageSize: 15,
    orderBy: "drone_id",
    orderType: "ASC",
  });
  const [totalCount, setTotalCount] = useState(0);
  const [activityPopup, setActivityPopup] = useState(undefined)

  const handleTableStateChange = (state) => {
    setPagination((prev) => ({
      ...prev,
      pageNumber: state.pageNumber || 1,
      pageSize: state.pageSize || prev.pageSize,
      orderBy: state.orderBy || prev.orderBy,
      orderType: state.orderType || prev.orderType,
    }));
  };

  const handleSearch = (filterState, changedField) => {
    if (changedField === "searchString") {
      setSearchQuery(filterState.searchString || "");
      setPagination((prev) => ({
        ...prev,
        pageNumber: 1,
      }));
    }
  };

  const fetchDrones = async ({ pageNumber, pageSize, orderBy, orderType, search }) => {
    setIsLoading(true);
    try {
      const response = await API.getAllDronesForAdminAPI({ pageNumber, pageSize, search, orderBy, orderType });
      console.log("Response from API:", response);
      setDrones(response.drones || []);
      setTotalCount(response.drones?.[0].total_count || 0);
    } catch (error) {
      console.error("Error fetching drones data:", error);
      setDrones([]);
      setTotalCount(0);
    } finally {
      setIsLoading(false);
    }
  }

  const fetchDronesCSV = async ({ pageNumber, pageSize, orderBy, orderType, search }) => {
    try {
      setIsLoadingCSV(true)
      setActivityPopup({
        open: true,
        item: "WAIT",
        icon: "WAIT",
        msg: 'Please wait while creating csv file.',
      })
      const response = await API.getAllDronesCSVForAdminAPI({ search, orderBy, orderType, isPdf: true });
      setIsLoadingCSV(false)
      if (response == 200) {
        setActivityPopup({
          open: true,
          item: "COMPLETE",
          icon: "COMPLETE",
          msg: 'File downloaded successfully.',
        })
      } else {
        setActivityPopup({
          open: true,
          item: "ERROR",
          icon: "ERROR",
          msg: 'Data not found.',
        })
      }
    } catch (e) {
      setIsLoadingCSV(false)
      setActivityPopup({
        open: true,
        item: "ERROR",
        icon: "ERROR",
        msg: e.message || 'Error',
      })

    }
  }

  useEffect(() => {
    const timeoutId = setTimeout(
      () => {
        fetchDrones({
          ...pagination,
          search: searchQuery,
        });
      },
      searchQuery ? 500 : 0
    );

    return () => clearTimeout(timeoutId);
  }, [pagination, searchQuery]);


  return (
    <div className="wrapper">
      <div className="right-content-new">
        <div className="top-bar-new" style={{ display: "flex" }}>
          <div className="top-bar-text-new">All Drones</div>
        </div>

        <ActivityPopup
          item={activityPopup?.item}
          open={activityPopup?.open}
          icon={activityPopup?.icon}
          action={activityPopup?.action}
          msg={activityPopup?.msg}
          close={() => { setActivityPopup(undefined) }}
          onClickOk={() => { }}
        />
        <div className="main-content-new">
          <div className="services-content-title" style={{ margin: '10px 0px' }}>Drones ({totalCount})</div>
          <SearchHeader
            onFilterDataChange={handleSearch}
            searchString={searchQuery}
            placeholder="Search drones..."
            middleComponent={
              <div>
                <ButtonWithIcon
                  text={isLoadingCSV ? "Downloading..." : "Download CSV"}
                  icon={downloadBurron}
                  isDisabled={isLoadingCSV || isLoading}
                  isIconLeft={true}
                  fontSize={'16px'}
                  iconWidth={'18px'}
                  // isBtnActive={true}
                  borderRadius={'10px'}
                  onClick={() => {
                    fetchDronesCSV({
                      ...pagination,
                      search: searchQuery,
                    })
                  }}
                  color={"white"}
                  backgroundColor={'#0F5EFF'}
                />
              </div>
            }
          />

          <div style={{ height: "calc(100% - 150px)", overflowY: "auto" }}>
            <TableView
              columns={[
                { Header: "Drone ID", width: '20%', accessor: "drone_id", isSortable: true },
                { Header: "UIN", width: '13%', accessor: "uin", isSortable: true },
                { Header: "Drone Name", width: '13%', accessor: "drone_name", isSortable: true },
                { Header: "Owner Email", width: '20%', accessor: "username", isSortable: true },
                { Header: "GCS Build Number", width: '13%', accessor: "green_build_number", isSortable: true },
                { Header: "Firmware Version", width: '15%', accessor: "firmware_version_number", isSortable: true },
              ]}
              data={drones}
              isLoading={isLoading}
              pageNumber={pagination.pageNumber}
              pageSize={pagination.pageSize}
              count={totalCount}
              onStateChange={handleTableStateChange}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminDrones;
